<h1 mat-dialog-title>{{dialogTitle | translate}}</h1>
<div mat-dialog-content>
  <ng-container *ngFor="let message of arrayMessage">
    <p *ngIf="message">{{message | translate}}</p>
  </ng-container>
</div>  
<div mat-dialog-actions>
  <button mat-raised-button *ngFor="let button of arrayButton" (click)="onBtnModalClick($event, button)">{{button.ButtonText | translate}}</button>
</div>